import { ChangeSourceType } from 'ag-common-lib/lib/lists/change-logs/change-source-type.enum';

export enum DeleteConferenceKeys {
  conferenceDbId = 'conferenceDbId',
  actionName = 'actionName',
}

export interface DeleteConference {
  [DeleteConferenceKeys.conferenceDbId]: string;
  [DeleteConferenceKeys.actionName]?: ChangeSourceType;
}
